$(function () {

    if($('#custom-checkout').length){
        $("#custom-checkout form").prepend(
            `<div id="form-widzard" class="d-flex mb-3">
                <span class="step step--1 current">01</span>
                    <span class="separator"></span>
                <span class="step step--2">02</span>
            </div>`
        )

        $("#custom-checkout form > fieldset").prepend(
            `<div class="form-step form-step--2" style="display: none"></div>`
        );
        $("#custom-checkout form > fieldset > div").appendTo('.form-step--2');
        $(".btn-toolbar").appendTo('.form-step--2');
        $('.btn-toolbar').append(`<button class='btn btn-primary text-uppercase btn--next--step2 mb-1'>Proceed to payment</button> <button class='btn btn-light btn--back--step2 mb-1'>Go Back</button>`);
        $(".btn-toolbar").addClass('d-flex');

        $("#custom-checkout form > fieldset").prepend(
            `<div class="form-step form-step--1"></div>`
        );

        $(".component--contact-info").appendTo('.form-step--1');
        $(".component--billing").appendTo('.form-step--1');
        $(".component--shipping").appendTo('.form-step--1');
        $(".component--shipping-method").appendTo('.form-step--1');


        $(".form-step--1").append(`<div class="mt-7 button-container"><button class='btn btn-primary btn--next btn--next--step1'>Continue</button></div>`);


        $(".optionset li.valManual").after(
            `<li class="val-manual-detail body-copy option-detail" style="display: none">
                <div>
                    <p>Please deposit payment of <strong class="val-manual-detail__price">${$('.price--total-checkout').text()}</strong> into bank account <strong>${fw.AccountNo}</strong> using <strong>#${orderInfo.reference}</strong> as the reference number.</p> 
                    <p>Your order will be processed once payment is received.</p>
                </div>
            </li>`
        );

        $(".optionset li.valPaymentExpress_PxPay label").text('Credit/Debit Card');

        $("input[type=radio][name=SilverShop-Checkout-Component-Payment_PaymentMethod]").change(function () {
            var curValue = getSelectedPaymentMethod();
            if(curValue == 'Manual'){
                $(".val-manual-detail").slideDown();
            }else{
                $(".val-manual-detail").slideUp();
            }
        });

        $("#custom-checkout .btn--next--step2").click(function (e) {
            e.preventDefault();
            var $input = $("#PaymentForm_OrderForm_SilverShop-Checkout-Component-Payment_PaymentMethod");

            if(getSelectedPaymentMethod()){
                $(this).parent().removeClass('has-error');
                if($(this).next().hasClass('error')){
                    $(this).next().remove();
                }

                $("#PaymentForm_OrderForm_action_checkoutSubmit").click();
            }else{

                $input.parent().addClass('has-error');
                if(!$input.next().hasClass('error')){
                    $input.after("<div class='error'>Please select an option</div>");
                }

            }
        });

        $("#custom-checkout .btn--next--step1").click(function (e) {
            e.preventDefault();

            $('#custom-checkout input[type=text][required]:visible, #custom-checkout input[type=number][required]:visible').each(function () {
                if($(this).val().trim() === ""){
                    $(this).parent().addClass('has-error');
                    if(!$(this).next().hasClass('error')){
                        $(this).after("<div class='error'>Please enter the value</div>");
                    }
                }else{
                    $(this).parent().removeClass('has-error');
                    if($(this).next().hasClass('error')){
                        $(this).next().remove();
                    }
                }
            });

            $('#custom-checkout input[type=email][required]:visible').each(function () {
                var email = $(this).val();
                if(!validateEmail(email)){
                    $(this).parent().addClass('has-error');
                    if(!$(this).next().hasClass('error')){
                        $(this).after("<div class='error'>Email address is incorrect</div>");
                    }
                }else{
                    $(this).parent().removeClass('has-error');
                    if($(this).next().hasClass('error')){
                        $(this).next().remove();
                    }
                }
            });

            if($("div.error:visible").length == 0){
                $('.form-step--1').hide();
                $('.form-step--2').show();


                $('.val-manual-detail__price').text($('.price--total-checkout').eq(0).text());

                $("#form-widzard .step").removeClass('current');
                $("#form-widzard .step--2").addClass('current');
                setTimeout(function () {
                    scrollToWidard();
                },100);
            }else{
                scrollToError();
            }
        });

        $("#custom-checkout .btn--back--step2").click(function (e) {
            e.preventDefault();
            $('.form-step--2').hide();
            $('.form-step--1').show();

            $("#form-widzard .step").removeClass('current');
            $("#form-widzard .step--1").addClass('current');

            scrollToWidard();
        });

        $('input[name=ShippingMethodComp_ShippingMethodID]').change(function () {
             var methodID = getSelectedShippingMethod();
             var shippingPrice = shippingMethods[methodID];
             $('.price--shipping').text(formatMoney(shippingPrice));
             var priceWithShipping =  shippingPrice + orderInfo.deposit;
             $('.price--deposit').text(formatMoney(priceWithShipping) + ' NZD');
        });
    }
});

function formatMoney(number){
    if(number == 0){
        return 'Free';
    }

    var decPlaces = 2;
    var decSep = ".";
    var thouSep = ",";
    decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
        decSep = typeof decSep === "undefined" ? "." : decSep;
    thouSep = typeof thouSep === "undefined" ? "," : thouSep;
    var sign = number < 0 ? "-" : "";
    var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
    var j = (j = i.length) > 3 ? j % 3 : 0;

    return '$' + sign +
        (j ? i.substr(0, j) + thouSep : "") +
        i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
        (decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "");
}

function getSelectedShippingMethod() {
    return $("input[type=radio][name=ShippingMethodComp_ShippingMethodID]:checked").attr('value');
}

function getSelectedPaymentMethod() {
    return $("input[type=radio][name=SilverShop-Checkout-Component-Payment_PaymentMethod]:checked").attr('value');
}

function scrollToWidard() {
    var element = document.getElementById('marker')
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function scrollToError() {
    var element = $('.error:visible').first().parent()[0];
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function validateEmail(mail) {
    return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(mail);
}
